import { gql } from '@apollo/client';

export const GET_USER_WORKSPACE_FORM_SUBMISSIONS = gql`
  query GetUserWorkspaceFormSubmissions($input: GetMyFormInput!) {
    submissions: getUserWorkspaceFormSubmissions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          updatedAt
          status
          createdAt
          statusDate
          status
          respondent {
            id
            lastName
            firstName
          }
          userRespondent {
            id
            lastName
            firstName
          }
          # Files are not inlined here: the table only renders metadata, and downloading every
          # attachment on the page made this query scale with attachment size. The per-row export
          # refetches the one submission it needs with files inlined.
          data(inlineFiles: false) {
            id
            answer
            question {
              id
              name
            }
          }
          workspaceForm {
            id
            template {
              jsonData
            }
          }
        }
      }
    }
  }
`;
